import { useState, useContext } from "react";
import RegisterButton from "./buttons/RegisterButton";
import { NavLink } from "react-router-dom";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { UserContext } from "../context/UserContext";
import { IoIosArrowDown } from "react-icons/io";

export default function Header() {
  const [showMobileNav, setShowMobileNav] = useState(false);
  const { user, logout } = useContext(UserContext);

  function handleClick() {
    setShowMobileNav(!showMobileNav);
  }

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      // Handle successful logout
    } else {
      // Handle logout error
      console.error(result.error);
    }
  };
  
  return (
    <header className="header">
      <div className="header_section">
        <h1 className="logo">
          <NavLink to="/home" className="logo_link"> 
            <img src="/logo.webp" alt="logo" className="logo_image" />
            {/* <h2>PayoutProphet</h2> */}
            <div className="logo_text">
              <span>Payout</span>
              <span>Prophet</span>
            </div>
          </NavLink>
        </h1>

        <nav className="nav">
          <ul className="nav_links">
            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/"}
              >
                home
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/about"}
              >
                about
              </NavLink>
            </li>
            <li className="predictions_parent">
              <NavLink>
                predictions
                <IoIosArrowDown className="up_icon" />
              </NavLink>
              <ul className="predictions">
                <li>
                  <NavLink
                    className={({ isActive }) => {
                      return isActive ? "active_link" : "";
                    }}
                    to={"/predictions/expert"}
                  >
                    expert tips
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => {
                      return isActive ? "active_link" : "";
                    }}
                    to={"/predictions/freebet"}
                  >
                    Free predictions
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/plans"}
              >
                plans
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/contact"}
              >
                contact
              </NavLink>
            </li>
          </ul>
        </nav>

        <div
          className={
            showMobileNav ? "mobile_nav mobile_nav_active" : "mobile_nav"
          }
        >
          <ul className="nav_links">
            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/"}
              >
                home
              </NavLink>
            </li>

            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/about"}
              >
                about
              </NavLink>
            </li>

            <li className="predictions_parent">
              <NavLink>
                predictions
                <IoIosArrowDown className="up_icon" />
              </NavLink>
              <ul className="predictions">
                <li>
                  <NavLink
                    className={({ isActive }) => {
                      return isActive ? "active_link" : "";
                    }}
                    to={"/predictions/expert"}
                  >
                    expert tips
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => {
                      return isActive ? "active_link" : "";
                    }}
                    to={"/predictions/freebet"}
                  >
                    Free predictions
                  </NavLink>
                </li>
              </ul>
            </li>

            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/plans"}
              >
                plans
              </NavLink>
            </li>

            <li>
              <NavLink
                className={({ isActive }) => {
                  return isActive ? "active_link" : "";
                }}
                to={"/contact"}
              >
                contact
              </NavLink>
            </li>
            {user ? (
              <div className="login_register_btn_contaner_mobile">
                <h4>Welcome, {user?.username.split(" ")[0]}</h4>
                <RegisterButton
                  value={"Logout"}
                  className={"btn btn-register"}
                  handlePress={handleLogout}
                />
              </div>
            ) : (
              <div className="login_register_btn_contaner_mobile">
                <NavLink to={"/login"}>
                  <RegisterButton
                    value={"Login"}
                    className={"btn btn-register login"}
                  />
                </NavLink>
                <NavLink to={"/signup"}>
                  <RegisterButton
                    value={"Register"}
                    className={"btn btn-register"}
                  />
                </NavLink>
              </div>
            )}
          </ul>
        </div>
        {user ? (
          <div className="login_register_btn_contaner">
            <h5>Welcome, {user?.username.split(" ")[0]}</h5>
            <RegisterButton value={"Logout"} className={"btn btn-register"} handlePress={handleLogout}  />
          </div>
        ) : (
          <div className="login_register_btn_contaner">
            <NavLink to="/login">Login</NavLink>

            <NavLink to={"/signup"}>
              <RegisterButton
                value={"Register"}
                className={"btn btn-register"}
              />
            </NavLink>
          </div>
        )}

        <button className="menu_btn" onClick={handleClick}>
          {!showMobileNav ? <IoMdMenu /> : <IoMdClose />}
        </button>
      </div>
    </header>
  );
}
